// Worker slots: how many steps (and copies of steps) a workspace runs at
// once, whatever workflow, task or job they belong to (state.json
// `worker_slots`, set by Corvus in Admin → a workspace → Features; absent
// = the default). The editor reads the workspace's own number with
// useWorkerSlots (api/workerSlots.ts); the default stands in until it has.
// A leaf module (rules.ts re-exports it), so api/workerSlots.ts, which the
// nav reads the capacity route through, keeps the editor's rules out of the
// shell's first bundle.

export const DEFAULT_WORKER_SLOTS = 8;
export const MIN_WORKER_SLOTS = 1;
export const MAX_WORKER_SLOTS = 48;
